<template>
  <div>
    <analysis-header :totalAmount="totalAmount" ref="analysisHeader" title="Kampanya/Satış Analizi" @update-range="updateRange"></analysis-header>

    <b-card-title class="text-danger mt-2" v-if="loadChart && dataList.length==0">Seçilen tarihler arasında kayıt bulunamadı</b-card-title>

    <b-row class="match-height" v-show="dataList.length>0">
      <!-- Sipariş Tutarları Grafiği -->
      <b-col md="12" >
        <chartjs-horizontal-bar-chart :chartData="chartDataHorizontal" @select-row="selectRow" :loadChart="loadChart" :totalAmount="totalAmount" :heightChart="400"/>

        <!-- Row Detail -->
        <b-modal
        id="links-modal"
        :visible="detailPopup"
        v-if="detailPopup"
        size="xl"
        :title="selectedData.campaign_name"
        ok-only
        ok-title="Kapat"
        @change="detailPopup=!detailPopup" >
        <b-card>
          <b-card-title class="mb-1 d-flex justify-content-between w-100">
            <div>
              {{ selectedData.total_count }} Adet / {{ priceFormat(selectedData.total_amount) }}
            </div>
          </b-card-title>
          
          <b-card-sub-title class="mb-2">
            <b class="text-primary"> {{ formatDate(getRangeDate[0])}} - {{ formatDate(getRangeDate[1]) }}</b> Sipariş Detayları
          </b-card-sub-title>
          
          <div class="row">
            <b-col md="12">
              <!-- Sipariş Datası sağda açılacak -->
              <link-analysis :groupId="selectedData.group_id" :dateRange="getRangeDate"/>
            </b-col>          
          </div>
          </b-card>
        </b-modal>

        <!-- Row Detail End -->

      </b-col>
    </b-row>    
  </div>
</template>
  
  <script>
  import ChartjsHorizontalBarChart from './ChartjsHorizontalInfluencer.vue'
  import AnalysisHeader from './AnalysisHeader.vue'
  import { BRow, BCol, BCard, BCardHeader, BButton, BCardSubTitle, BCardTitle, BModal } from 'bootstrap-vue'
  import vSelect from 'vue-select';
  import linkAnalysis from '../analysis/Links.vue'
  import InfluencerLinkBtn from '@/components/link/InfluencerLinkBtn.vue';
  
  export default {
    components: {
      BRow,
      BCol,
      BCard,
      BButton,
      BCardHeader,
      BCardSubTitle,
      BCardTitle,

      ChartjsHorizontalBarChart,
      AnalysisHeader,
      linkAnalysis,
      InfluencerLinkBtn,
      vSelect,
      BModal
    },
    data() {
      return {  
        detailPopup:false,
        chartData: {
          labels: [],
          datasets: [
            {
              data: [],
              backgroundColor:  '#bed0e1',
              borderColor: 'transparent',
              barThickness: 15
            },
          ],
        },
        dataList:[],
        chartDataHorizontal: {},
        loadChart:false,
        selectedData:{},
      }
    },
    created () {
      // İlk yüklemede rangeDate bu ay bilgilerini al
      const today = new Date();
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const rangeDate = [this.changeFormat(firstDayOfMonth), this.changeFormat(today)];
      this.getData(rangeDate[0], rangeDate[1]);
    },
    methods: {
      updateRange(range){
        // Tarihleri API'ye gönder
        this.getData(range[0], range[1]);
      },
      getData(startDate=null,endDate=null) {
        this.$http.get('/analysis/multi-links', { params: { start_date: startDate, end_date: endDate } }).then((response) => {
          // Dönen fenomen listesini al
          const data = response.data.data;

          // Fenomenleri total_amount değerine göre azalan sırayla sıralayın
          this.dataList = data.sort((a, b) => b.total_amount - a.total_amount);

          // Grafikleri güncelle
          this.updateChartData();     

        }).catch((error) => {
          console.error('Veri alımı sırasında bir hata oluştu:', error);
        });
      },
      updateChartData(){
        this.loadChart=false;
        
        const labels = this.dataList.map((item)=>{
          return item.campaign_name 
        })
        const dataAmount = this.dataList.map((item)=>{
          return [item.total_count, item.total_amount]
        })

        this.chartDataHorizontal = JSON.parse(JSON.stringify(this.chartData));
        this.chartDataHorizontal.labels = [...labels];
        this.chartDataHorizontal.datasets[0].data = [...dataAmount]; // Burada döngüsel yapı olmamalı

        setTimeout(() => {
          this.loadChart=true 
        }, 500);
      },
      selectRow(data) {
        this.detailPopup = true; // Popup'u göster
        
        // Seçilen fenomeni al
        this.selectedData = this.dataList[data];
      },
    },
    computed: {
      totalAmount() {
        return this.dataList.reduce((total, item) => total + parseFloat(item.total_amount), 0);
      },
      
      getRangeDate() {
        return this.$refs.analysisHeader.rangeDate;
      },
    },
    watch: {
    },
  }
  </script>
  
  <style>
  
  .row-detail-popup{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  </style>